import { graphql } from 'react-relay';

export const tritxApplyRefund = graphql`
  mutation tritxApplyRefundMutation(
    $refundId: String!
    $phoneNumber: String!
    $bank: String!
    $accountOwner: String!
    $accountNo: String!
    $metaProperties: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
  ) {
    tritxApplyRefund(
      refundId: $refundId
      phoneNumber: $phoneNumber
      bank: $bank
      accountOwner: $accountOwner
      accountNo: $accountNo
      metaProperties: $metaProperties
      applyUtm: { source: $utmSource, medium: $utmMedium, campaign: $utmCampaign, term: $utmTerm, content: $utmContent }
    ) {
      result
      errors {
        code
      }
    }
  }
`;
